import { NetworkBasePopUp } from '../NetworkBasePopUp';

export class TagsManagementPopUp extends NetworkBasePopUp<undefined> {
  protected title = '';
  protected extraDialogConfigs = {};
  protected extModelReference = 'Application.modules.network.model.eps.protectedEntity';
  protected async handleConfirmButtonClicked(event: CustomEvent) {}

  protected customSetup() {
    const gzTagsWindow = Ext.create('Application.modules.network.view.eps.gzTagsWindow', {
      tagsAction: this.data.specifics.action,
      protectedEntities: this.data.targets,
    });
    gzTagsWindow.show();
  }
}
